import React from 'react'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from './ui/dropdown-menu'
import { Button } from './ui/button'
import { useCurrency } from '../context/CurrencyContext'

export function CurrencySelector() {
  const { currency, setCurrency, currencies } = useCurrency()
  const current = currencies[currency]

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="flex items-center gap-1 px-2 py-1.5 text-white/70 hover:text-white hover:bg-white/10 h-auto"
          data-testid="currency-switcher"
        >
          <span className="text-xs font-bold text-brand-primary">{current.symbol}</span>
          <span className="text-xs font-semibold tracking-wide">{current.code}</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-44 bg-brand-secondary border-white/10">
        {Object.values(currencies).map((cur) => (
          <DropdownMenuItem
            key={cur.code}
            onClick={() => setCurrency(cur.code)}
            className={`cursor-pointer text-sm ${
              currency === cur.code
                ? 'text-brand-primary bg-brand-primary/10'
                : 'text-white/70 hover:text-white hover:bg-white/10'
            }`}
            data-testid={`currency-${cur.code}`}
          >
            <span className="font-bold mr-2 w-6 text-center text-brand-primary">{cur.symbol}</span>
            <span>{cur.code}</span>
            <span className="ml-auto text-xs text-white/40">{cur.name}</span>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
